<template>
  <div class="fangyuanPage">
    <div class="">
      <div v-show="showPage">
        <div>
          <!-- 校验码开始 -->
          <div
            class="ewmBoxWrap"
            :style="[
              { backgroundImage: `url(${item.boxBg})` },
              { backgroundRepeat: 'no-repeat' },
              { backgroundSize: '100% 100%' },
            ]"
          >
            <div class="ermTitle">
              <img :src="item.zsxx.topImg" alt="" class="imgClass" />
            </div>
            <div class="ewmBox">
              <!--左边-->
              <div
                class="ewmLeftBox2"
                :style="{ backgroundImage: `url(${item.scanBg})` }"
              >
                <div class="ewmImgBox2">
                  <vue-qr
                    :size="item.scanSize"
                    :margin="0"
                    :auto-color="true"
                    :dot-scale="1"
                    :text="codeUrl"
                    :style="[
                      { marginRight: `${item.marginLeft}px` },
                      { marginTop: `${item.marginTop}px` },
                    ]"
                  />
                </div>
              </div>
              <div class="ewmRightBox2">
                <img :src="item.zsxx.topImg2" alt="" class="imgClass" />
              </div>
            </div>

            <div
              class="ewmRightBox"
              :style="{ backgroundImage: `url(${item.codeBg})` }"
            >
              <div class="myboxWrap">
                <div class="myBox1" :style="{ color: item.zsxx.xxColor }">
                  <span
                    class="center"
                    :style="{
                      color: item.zsxx.numColor,
                    }"
                    >1</span
                  >对比实物标签与图片
                </div>
                <div class="myBox2" :style="{ color: item.zsxx.xxColor }">
                  <span
                    class="center"
                    :style="{
                      color: item.zsxx.numColor,
                    }"
                    >2</span
                  >观察图片中的文字、位置、编码是否相符
                </div>
                <div class="myBox3" :style="{ color: item.zsxx.remarkColor }">
                  以上特征均相符，则是真品，否则谨防假冒
                </div>
              </div>
            </div>
            <div class="style2_msgBox2">
              <div class="rightContent">
                <img class="logoIcon" :src="item.zsxx.logoIcon" />
                <p class="rightText1">工业互联网标识码：</p>
                <p class="rightText2">{{ handle ? handle : "---" }}</p>
              </div>
            </div>
            <div class="style2_msgBox3" :style="{ color: item.zsxx.remarkColor }">
              由国家工信部授权工业互联网标识解析二级节点（86.122）签发
            </div>
            <div class="style2_msgBox4" :style="{ backgroundColor: item.zsxx.infoBgColor, color: item.zsxx.infoLabelColor }">
              上次查询时间为：<span class="red" :style="{ color: item.zsxx.infoValueColor }">-----</span>
            </div>
            <div class="style2_msgBox5" :style="{ backgroundColor: item.zsxx.infoBgColor, color: item.zsxx.infoLabelColor }">
              上次查询地点为：<span class="red" :style="{ color: item.zsxx.infoValueColor }">-----</span>
            </div>
            <div class="style2_msgBox6" :style="{  color: item.zsxx.infoLabelColor }">
              <img
                src="https://apkpic.86122m.com/yimai_photos/customPage/template/fdj.png"
              />
              现在是第<span class="red" :style="{ color: item.zsxx.infoValueColor }">--</span>次查询
            </div>
            <div class="style2_msgBox7" :style="{ color: item.zsxx.remarkColor }">
              *若查询扫码次数过多，标识码可能被盗用，谨防假冒产品！
            </div>
            <div class="jumpBox" v-if="item.zsxx.jumpStyle == 1">
              <img
                class="jumpButton1"
                src="https://apkpic.86122m.com/custom/8569776c96884d28f9ddaad6767e6c61.png"
              />
            </div>
          </div>
          <!-- 校验码结束 -->
          <div
            class="swiperImg"
            :style="[
              { backgroundImage: `url(${item.certboxBg})` },
              { backgroundRepeat: 'no-repeat' },
              { backgroundSize: '100% 100%' },
            ]"
          >
            <div class="swiperWrap">
              <div class="swiperBox">
                <van-swipe
                  :autoplay="2000"
                  indicator-color="transparent"
                  :show-indicators="false"
                  @change="onSwipeChange"
                >
                  <van-swipe-item
                    v-for="(picItem, index) in item.zsxx.picList"
                    :key="picItem.url + index"
                  >
                    <van-image width="78%" :src="picItem.url" class="vanImgs" />
                  </van-swipe-item>
                </van-swipe>
              </div>
              <div class="swipeNum">
                <span class="swipeIndex">{{ activeIndex + 1 }}</span
                >/{{ item.zsxx.picList.length }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-show="!showPage" class="photosPage">
        <div class="logoBox">
          <img :src="item.xchy.logo" class="logo" />
        </div>
        <div class="pageTit">{{ item.xchy.title }}</div>
        <div class="newBody">
          <div class="newTitWrap">
            <div class="newTit">
              <div class="newEngTit">{{ item.xchy.infoEng }}</div>
              <div class="newCheTit">{{ item.xchy.infoTit }}</div>
            </div>
          </div>
          <div class="photoWrap newPhotosWrap">
            <video
              class="myVideo"
              controls="false"
              :poster="item.xchy.poster"
              object-fit="contain"
              :src="item.xchy.video"
            ></video>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Image as VanImage, Swipe, SwipeItem } from "vant";
import VueQr from "vue-qr";
export default {
  data() {
    return {
      selTabbar: null,
      activeIndex: 0,
      showPage: true,
      flodIndex: null, //记录折叠的index

      codeUrl: "",
      veridicalCode: "", // 防伪码
      errTip: false,
      // verState: 0, // 0 未验证 1 验证成功 2 验证失败
      txmDialogVisible: false,
    };
  },
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [VanImage.name]: VanImage,
    VueQr,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    verState: Number,
    handleLink: String,
    handle: String,
    query: {
      type: String,
    },
    h: {
      String,
    },
    codeData: {
      type: Object,
    },
  },
  computed: {
    imgStyle(picItem, item) {
      return (n, item) => {
        var wid;
        var pos;
        var str;
        // pos = item.align
        if (n.width) {
          wid = n.width;
        } else {
          wid = "100%";
        }
        str = "width: " + wid;
        if (pos === "left") {
          console.log("pos", pos);
          str = `width: ${wid};float: ${pos}`;
        } else if (pos === "right") {
          console.log("pos", pos);
          str = `width: ${wid};float: ${pos}`;
        } else if (pos === "center") {
          console.log("pos", pos);
          str = `width: ${wid};margin: 0 auto;`;
        }
        return str;
      };
    },
  },
  mounted() {
    this.selTabbar = this.item.tabbar[0];
    this.$emit("fyChangeTab", this.selTabbar);
    this.setCode();
  },
  methods: {
    setCode() {
      if (this.handleLink) {
        this.codeUrl = this.handleLink;
      } else {
        this.codeUrl = "https://api.86122m.com/h?h=aaamz";
      }
    },
    // 点击验证
    toVeridical() {
      if (!this.veridicalCode.trim()) {
        this.errTip = true;
        this.$emit("veridicalCode", this.veridicalCode);
      } else {
        this.errTip = false;
        // 调接口
        this.$emit("veridicalCode", this.veridicalCode);
      }
    },
    changeTabbar(item) {
      this.showPage = true;
      if (this.flodIndex) {
        let isFlod = this.item.zsxx.infoMain[this.flodIndex].isFold;
        this.item.zsxx.infoMain[this.flodIndex].isFold = !isFlod;
      }
      this.selTabbar = item;
      this.$emit("fyChangeTab", this.selTabbar);
    },
    onSwipeChange(event) {
      let activeIndex = event;
      this.activeIndex = activeIndex;
    },
    morePhotos() {},
    changePage() {
      this.showPage = false;
    },
    changeFlod(index, isFlod) {
      this.flodIndex = index;
      this.item.zsxx.infoMain[index].isFold = !isFlod;
      console.log(
        "----- this.item.zsxx.infoMain[index].isFold-----",
        this.item.zsxx.infoMain[index].isFold,
      );
      // this.item.zsxx.infoMain[index].isFold = !this.item.zsxx.infoMain[index].isFold
    },
  },
};
</script>
<style scoped>
.fangyuanPage {
  background: rgba(241, 249, 252, 1);
  position: relative;
}
.logo {
  width: 96px;
  height: 60px;
  margin-left: 37px;
  padding-top: 46px;
  margin-bottom: 23px;
}
.pageTit {
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #fff;
  text-align: left;
  padding-bottom: 45px;
  padding-left: 37px;
}
.swipeNum {
  font-size: 14px;
  font-family: DIN;
  font-weight: bold;
  color: #7f849a;
  text-align: center;
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}
.swipeNum .swipeIndex {
  color: #2B3E20;
  font-size: 20px;
}
.myVideo {
  width: 100%;
  margin: 25px auto 0px;
  border-radius: 10px;
  overflow: hidden;
}
.photosPage {
  min-height: 200px;
}
.logoBox {
  text-align: left;
}
.newBody {
  border: 1px solid #fff;
  background: #edf0ff;
  box-shadow: 0px 0px 10px 10px rgba(154, 188, 230, 0.7) inset;
  width: 90%;
  box-sizing: border-box;
  margin: 0 auto 23px;
  border-radius: 10px;
  padding: 35px 20px;
}
.newTitWrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #fff;
  padding-bottom: 23px;
}
.newEngTit {
  font-size: 12px;
  font-family: Arial;
  font-weight: 400;
  color: #707b99;
  padding-bottom: 10px;
  text-align: left;
}
.newCheTit {
  font-size: 23px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #333333;
  text-align: left;
}
.newTit {
  flex: 1;
  padding-right: 20px;
}
.swiperImg {
  width: 100%;
  background: url("https://apkpic.86122m.com/custom/7ec91210dd2efc37adbac3eacc466f0f.png")
    no-repeat center center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}
.swiperWrap {
  width: 318px;
  height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 440px 0 46px 0;

  background: rgba(246, 251, 251, 0.9);
  border-radius: 25px;
  border: 2px solid #ffffff;
  position: relative;
}
.swiperName {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 31px;
  padding-bottom: 25px;
  font-family: MaoKenWangFengYaSong;
  font-weight: 400;
  font-size: 18px;
  color: #231815;
}
.blackText {
  color: #231815;
}
.redText {
  color: #d7434a;
}
.swiperBox {
  width: 237px;
  height: 320px;
  background: url("https://apkpic.86122m.com/custom/5e33228eae04424983021ec1569d51ba.png")
    no-repeat;
    background-position: center 0;
  background-size: 90%;
  padding-top: 17px;
}
.ewmBoxWrap {
  height: auto;
  font-size: 16px;
  background-size: cover;
  position: relative;
  padding: 0 20px;
  padding-bottom: 47px;
}
.ewmBox {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.ewmRightBox {
  height: 85px;
  display: border-box;
  margin-top: 22px;
  background-size: 100%;
  overflow: hidden;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.ewmRightBoxTit1 {
  font-family: Source Han Sans CN;
  font-weight: 500;
  font-size: 15px;
  color: #2c2e33;
  line-height: 15px;
}
.ewmRightBoxTit2 {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 12px;
  color: #675b22;
  line-height: 12px;
  margin-top: 9px;
}

.style2_msgBox2 {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-left: 10px;
  border-bottom: 1px dashed #567a3f;
  width: 80%;
  position: relative;
  margin-top: 30px;
}
.rightContent {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
}
.style2_msgBox2 .rightContent .rightText1 {
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  color: #3e362c;
  line-height: 20px;
  padding-left: 10px;
  text-align: left;
}
.style2_msgBox2 .rightContent .rightText2 {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #242326;
  line-height: 20px;
  padding-left: 10px;
  text-align: left;
}
.style2_msgBox3,
.style2_msgBox7 {
  font-size: 10px;
  font-weight: 400;
  color: #567a3f;
  line-height: 20px;
  text-align: left;
  padding-left: 10px;
  margin-top: 5px;
}
.style2_msgBox7 {
  color: #3e3924;
  margin-top: 10px;
}
.style2_msgBox4,
.style2_msgBox5 {
  height: 24px;
  font-size: 12px;
  font-weight: 400;
  color: #2c2f3e;
  text-align: left;
  background: #f0fcf4;
  width: 70%;
  margin: 10px 0 10px 8px;
  border-radius: 4px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 10px;
}
.style2_msgBox4 .red,
.style2_msgBox5 .red,
.style2_msgBox6 .red {
  color: #bb132f;
}
.style2_msgBox6 {
  font-size: 14px;
  font-weight: 400;
  color: #3e362c;
  text-align: left;
  padding-left: 10px;
  margin-top: 15px;
}
.style2_msgBox6 img {
  width: 14px;
  height: 14px;
  vertical-align: middle;
  margin-right: 5px;
}
.ewmBoxTitle1 {
  font-family: Source Han Serif CN;
  font-weight: 600;
  font-size: 12px;
  line-height: 12px;
  color: #656453;
}
.ewmBoxTitle2 {
  font-family: MaoKenWangFengYaSong;
  font-weight: 400;
  font-size: 30px;
  color: #231815;
  line-height: 30px;
  margin-top: 12px;
}
.myboxWrap {
  width: 100%;
  padding: 0 0 0 15px;
}
.myBox1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 12px;
  color: #151515;
  line-height: 11px;
}
.myBox2 {
  font-size: 12px;
  color: #211f1f;
  text-align: left;
  vertical-align: middle;
  display: flex;
  flex-direction: row;
  align-items: center;
  line-height: 18px;
}
.myBox3 {
  font-size: 12px;
  color: #675b22;
  text-align: left;
  vertical-align: middle;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 500;
  line-height: 18px;
  padding-left: 10px;
}
.myBox1 span,
.myBox2 span {
  width: 20px;
  height: 20px;
  font-size: 14px;
  color: #d9eace;
  margin-right: 5px;
  line-height: 18px;
  font-weight: 500;
  vertical-align: middle;
}
.center {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
.jumpBox {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 25px;
  margin-right: -20px;
}
.jumpButton1 {
  width: 136px;
  height: 42px;
}
.newPhotosWrap {
  display: flex;
  justify-content: center;
}

/* 二维码标题 新改动css*/
.ermTitle {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 38px 0 25px 0;
}
.ermTitle img {
  width: 190px;
  height: 48px;
}
.ewmRightBox2 {
  width: 171px;
  height: 47px;
}
.ewmRightBox2 img {
  width: 100%;
  height: 100%;
}
.ewmLeftBox2 {
  width: 147px;
  height: 98px;
  background-size: 100% 100%;
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
}
.ewmImgBox2 {
  margin: 0;
}
.logoIcon {
  width: 21px;
  height: 23px;
}
</style>
